// from JSP?
/* global teacherId teacherVerify teacherNameEncoded */

// Is this file needed? It was accidentally excluded from Sept 2024 to May 2025 and no one noticed
// https://github.com/donorsChoose/donorschoose-web/commit/e842fe7bbd8e8808e92c8ef6ac696744ecf01598
// More discussion at https://github.com/DonorsChoose/donorschoose-web/pull/11698/files#r2093184182
$(document).ready(function () {
    let teacherURLString = baseURL + 'profile/teacher.html';
    teacherURLString += '?teacher=' + teacherId;
    teacherURLString += '&verify=' + teacherVerify;
    if (qsParam.page != null) {
        teacherURLString += '&page=' + qsParam.page;
    }

    window.createCookie('searchTermsURL', teacherURLString, 1);
    window.createCookie('searchTermsDesc', window.b64EncodeUnicode(teacherNameEncoded), 1);

    window.setRecentTeacherReferredDonorCookieBasedOnTeacherPage(teacherId);
});
